import { Params } from '@angular/router';
import { createFeatureSelector, createSelector } from '@ngrx/store';

import { Event } from '@planone/bau365/util-fair-data';
import { selectRouteParams } from '@planone/shared/util-ngrx';

import { DATA_ACCESS_EVENTS_FEATURE_KEY, EventsState } from './data-access-events.reducer';

import { getExhibitorId } from '../../exhibitors/entity/data-access-exhibitors.selectors';

export const getDataAccessEventsState = createFeatureSelector<EventsState>(DATA_ACCESS_EVENTS_FEATURE_KEY);

export const getEventIds = createSelector(getDataAccessEventsState, (state: EventsState) => Object.keys(state.events));

export const getEvents = createSelector(getDataAccessEventsState, (state: EventsState) => Object.values(state.events));

export const getEventId = createSelector(selectRouteParams, (routerParams: Params) => {
  return typeof routerParams !== 'undefined' && routerParams['id'] != null ? routerParams['id'] : undefined;
});

export const getContributorId = createSelector(selectRouteParams, (routerParams: Params) => {
  return typeof routerParams !== 'undefined' && routerParams['contributorId'] != null
    ? routerParams['contributorId']
    : undefined;
});

export const getEvent = createSelector(getDataAccessEventsState, getEventId, (state: EventsState, eventId: string) => {
  return typeof eventId !== 'undefined' ? state.events[eventId] : undefined;
});

export const getContributor = createSelector(
  getDataAccessEventsState,
  getEventId,
  getContributorId,
  (state: EventsState, eventId: string, contributorId: string) =>
    state.events[eventId]?.contributors?.find((contributor) => contributor.id === contributorId)
);

export const getActiveEventLoadingState = createSelector(
  getDataAccessEventsState,
  (state: EventsState) => state.activeEventLoading
);
export const getActiveEventError = createSelector(getDataAccessEventsState, (state: EventsState) =>
  state.activeEventError ? state.activeEventError : undefined
);

export const getEventById = createSelector(
  getDataAccessEventsState,
  (state: EventsState, props: { eventId: string }) => {
    if (state.events && state.events[props.eventId]) {
      return state.events[props.eventId];
    }

    return undefined;
  }
);

export const getExhibitorEvents = createSelector(
  getDataAccessEventsState,
  getExhibitorId,
  (state: EventsState, exhibitorId: string) =>
    Object.values(state.events).filter((event) => event.exhibitor_id === exhibitorId)
);

export const getFilteredEventList = createSelector(
  getDataAccessEventsState,
  getEvent,
  getEvents,
  (state: EventsState, event?: Event, events?: Event[]) =>
    event && events
      ? events?.filter((object) => object.id !== event.id && object.exhibitor_id === event.exhibitor_id)
      : undefined
);
